<template>
    <div id="information-asset-component">
        <v-card class="elevation-0">
            <v-card-title>
                <header-widget-component :is_open="is_open" widget_name="information-asset-component"
                                         :title="$t('information_asset_component.title')"
                />
            </v-card-title>

            <v-expand-transition>
                <div v-show="is_open">
                    <v-card-text class="pt-2 pb-4">
                        <v-row class="pb-4" data-cy="row-brand-reference">
                            <v-col class="pb-0 pt-0 text-center" cols="4" v-if="asset.brand_reference">
                                <span class="font-12 font-color-light">
                                    {{ $t('information_asset_component.brand') }}
                                </span>
                                <p class="asset-information">
                                    {{
                                        asset.brand_reference ? asset.brand_reference.name : $t('global.not_specified')
                                    }}
                                </p>
                            </v-col>

                            <v-divider vertical color="white" v-if="asset.brand_reference"/>

                            <v-col class="pb-0 pt-0 text-center" :cols="asset.brand_reference ? 4 : 6">
                                <span class="font-12 font-color-light">
                                    {{ $t('information_asset_component.model') }}
                                </span>
                                <p class="asset-information">
                                    {{
                                        asset.brand_reference ? asset.model_reference.trade_name : displayToHumanTypeAsset(asset.type)
                                    }}
                                </p>
                            </v-col>

                            <v-divider vertical color="white"/>

                            <v-col class="pb-0 pt-0 text-center" :cols="asset.brand_reference ? 4 : 6">
                                <span class="font-12 font-color-light">
                                    {{ $t('information_asset_component.liquid') }}
                                </span>
                                <p class="asset-information">{{ asset.asset_liquid.name }}</p>
                            </v-col>
                        </v-row>

                        <v-row class="pb-2" v-if="asset.brand_reference === null" data-cy="unknown-brand-reference-info">
                            <v-col class="pb-0 pt-0 text-center" cols="3">
                                <span class="font-12 font-color-light">
                                    {{ $t('information_asset_component.capacity') }}
                                </span>
                                <p class="asset-information">
                                    {{ numberWithSpaces(Math.round(asset.volume_total)) }} L
                                </p>
                            </v-col>

                            <v-divider vertical color="white"/>

                            <v-col class="pb-0 pt-0 text-center" cols="3">
                                <span class="font-12 font-color-light">
                                    {{ $t('information_asset_component.height') }}
                                </span>
                                <p class="asset-information">{{ asset.height }} cm</p>
                            </v-col>

                            <v-divider vertical color="white"/>

                            <v-col class="pb-0 pt-0 text-center">
                                <span class="font-12 font-color-light">
                                    {{ $t('information_asset_component.length') }}
                                </span>
                                <p class="asset-information">{{ asset.length }} cm</p>
                            </v-col>

                            <v-divider vertical color="white"/>

                            <v-col class="pb-0 pt-0 text-center">
                                <span class="font-12 font-color-light">
                                    {{ $t('information_asset_component.width') }}
                                </span>
                                <p class="asset-information">{{ asset.width }} cm</p>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
    </div>
</template>

<script>
import HeaderWidgetComponent from "./HeaderWidgetComponent";

export default {
    name: "InformationAssetComponent",
    components: {HeaderWidgetComponent},
    props: {
        is_open: {
            type: Boolean,
            required: false,
            default: false
        },
        asset: {
            type: Object,
            required: true,
            default: function () {
                return {
                    model_reference: '',
                    asset_liquid: {name: ''},
                    volume: null,
                    height: null,
                    length: null,
                    width: null
                };
            }
        }
    },
    methods: {
        displayToHumanTypeAsset(type) {
            switch (type) {
                case 1:
                    return this.$t('information_asset_component.vertical_cylindrical');
                case 2:
                    return this.$t('information_asset_component.rectangular');
                case 3:
                    return 'IBC';
                case 4:
                    return this.$t('information_asset_component.cylindrical_lying');
                default:
                    return this.$t('global.not_specified')
            }
        }
    }
}
</script>